// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"ca5d022c","498":"a9f161fa","513":"397b4900"}[chunkId] + ".chunk.js";
};